<template>
    <div :id="['lightbox-' + identifierId]"
         class="form-modal-container d-flex flex-column justify-content-center align-items-center h-100">
        <div class="w-100 h-100">
            <div class="form-overlay-background"></div>
            <div class="form-template2 form-internal-container ratio16-9 h-100"
                 :class="[formSizeClass]"
                 :id="['form-template-' + identifierId]">
                <div class="container-form h-100">
                    <div class="row h-100 m-0">
                        <div class="col-lg-6 h-100">
                            <div class="row template-header"
                                 :class="['class-template-header-' + identifierId]">
                                <div class="col-12 container-logo" v-html="logo1">
                                </div>
                                <div class="col-12 container-title d-block d-sm-block d-md-block d-lg-none">
                                    <div class="form-title">{{ formTitle }}</div>
                                    <div class="form-description my-1">{{ formDescription }}</div>
                                </div>
                            </div>
                            <div class="questions-container">
                                <div class="carousel slide carousel-container" data-bs-wrap="false"
                                     :id="'carousel-' + identifierId">
                                    <form method="post" class="m-0"
                                          :name="'form-' + identifierId"
                                          :id="'form-' + identifierId"
                                          @submit.prevent="submitHandler">
                                        <Questions
                                            :key="identifierId"
                                            :additional-percentage-height="additionalPercentageHeight"
                                            :existValueOther="existValueOther"
                                            :form-size-class="formSizeClass"
                                            :has-pages="true"
                                            :hotspot="hotspot"
                                            :identifierId="identifierId"
                                            :input-text="inputText"
                                            :pages="pages"
                                            :page-active="pageActive"
                                            :question-image-required="questionImageRequired"
                                            :store="store"
                                            :translate-labels="translateLabels"
                                            :type-identifier="typeIdentifier"
                                            :form-errors="shouldShowErrors ? errors : {}"
                                            :has-submitted="hasSubmitted"
                                            @register-field="registerField"
                                            @field-change="handleFieldChange"
                                            @other-field-data="handleOtherFieldData"
                                        />
                                    </form>
                                </div>
                            </div>
                            <div class="d-none d-lg-block"
                                 :class="['text-mandatory-' + identifierId]">
                                <div class="text-mandatory">{{ translateLabels.textMandatoryFields }}</div>
                            </div>
                            <div class="row form-internal-footer d-sm-block d-md-block d-lg-none d-xl-none pb-3"
                                 :class="['class-template-footer-' + identifierId]">
                                <div class="row container-form-close"
                                     v-if="!formRequired">
                                    <div class="col">
                                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                                                @click="closeModal"></button>
                                    </div>
                                </div>
                                <div class="col-12 container-image-two m-0 p-0">
                                    <p class="text-mandatory-two">{{ translateLabels.textMandatoryFields }}</p>
                                    <div class="container-btn-two d-flex justify-content-sm-start justify-content-between"
                                         v-if="pages > 1">
                                        <button type="button" class="btn btn-secondary me-lg-3 mb-1 text-uppercase btn-back btn-support"
                                                v-bind:data-bs-target="'#carousel-' + identifierId" data-bs-slide="prev">{{ translateLabels.textBack }}</button>
                                        <button type="button" class="btn btn-primary me-lg-3 mb-1 text-uppercase btn-next btn-support"
                                                v-bind:data-bs-target="'#carousel-' + identifierId" data-bs-slide="next">{{ translateLabels.textNext }}</button>
                                        <button type="button" class="btn btn-primary me-lg-3 mb-1 text-uppercase d-none btn-submit btn-support"
                                                @click.prevent="submitHandler">{{ translateLabels.textButtonSubmit }}</button>
                                    </div>
                                    <div class="container-btn d-flex justify-content-sm-start justify-content-between"
                                         v-if="pages == 1">
                                        <button type="button" class="btn btn-primary me-lg-3 mb-1 text-uppercase btn-submit btn-support"
                                                @click.prevent="submitHandler">{{ translateLabels.textButtonSubmit }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="right-side col-lg-6 container-height d-none d-lg-block">
                            <div class="row container-form-close"
                                 v-if="!formRequired">
                                <div class="col">
                                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                                            @click="closeModal"></button>
                                </div>
                            </div>
                            <div class="row position-relative container-image">
                                <div class="col-12 position-relative container-height">
                                    <div v-html="image1"></div>
                                    <div class="container-title d-none d-lg-block">
                                        <p class="form-title">{{ formTitle }}</p>
                                        <p class="form-description mb-2">{{ formDescription }}</p>
                                    </div>
                                    <div class="container-btn"
                                         v-if="pages > 1">
                                        <button type="button" class="btn btn-secondary me-lg-3 mb-1 text-uppercase btn-back"
                                                v-bind:data-bs-target="'#carousel-' + identifierId" data-bs-slide="prev">back</button>
                                        <button type="button" class="btn btn-primary me-lg-3 mb-1 text-uppercase btn-next"
                                                v-bind:data-bs-target="'#carousel-' + identifierId" data-bs-slide="next">next</button>
                                        <button type="button" class="btn btn-primary me-lg-3 mb-1 text-uppercase d-none btn-submit"
                                                @click.prevent="submitHandler">submit</button>
                                    </div>
                                    <div class="container-btn"
                                         v-if="pages == 1">
                                        <button type="button" class="btn btn-primary me-lg-3 mb-1 text-uppercase btn-submit"
                                                @click.prevent="submitHandler">submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, computed, onMounted } from 'vue';
import { useForm } from 'vee-validate';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import Questions from "@/playerVue3/components/form/questions.vue";
import { prepareDataAndSave, replaceDataVariableInForm } from "@/playerVue3/services/form-service";

// INITIALIZE STORE & COMPOSABLES
const playerStore = usePlayerStore();

// PROPS & EMITS
const props = defineProps({
    configurationData: {
        type: String,
        required: false,
    },
    formDescription: {
        type: String,
        required: true,
    },
    formPosition: {
        type: String,
        required: false,
        default: '',
    },
    formRequired: {
        type: Boolean,
        required: false,
        default: false,
    },
    formSizeClass: {
        type: String,
        required: false,
        default: '',
    },
    formTitle: {
        type: String,
        required: true,
    },
    hotspot: {
        type: Object,
        required: false,
    },
    hotspotEmailTemplateId: {
        type: Number,
        required: false,
    },
    identifierId: {
        type: Number,
        required: true,
    },
    store: {
        type: Object,
        required: true
    },
    translateLabels: {
        type: Object,
        required: true,
    },
    typeIdentifier: {
        type: String,
        required: true,
    },
});

const emit = defineEmits(['setClose']);

// VeeValidate form setup con configuración lazy
const { validate, values, errors, setFieldValue, submitCount } = useForm({
    validateOnMount: false,    // No validar al montar
    initialValues: {},
});

// REACTIVE VARIABLES
const additionalPercentageHeight = ref(0);
const existValueOther = ref(false);
const inputText = ref(false);
const itemFirst = ref('');
const itemLast = ref('');
const myCarousel = ref('');
const pageActive = ref(1);
const pages = ref(0);
const questionImageRequired = ref(false);
const hasSubmitted = ref(false); // Flag para rastrear si ya se envió
const otherFieldsData = ref({}); // Nuevo: almacenar datos de campos "other"

const fields = ref({
    formID: playerStore.getFormID,
    formIsFromAttrAdditional: false,
    hotspotEmailTemplateID: props.hotspotEmailTemplateId,
    hotspotID: props.identifierId,
    vID: playerStore.getVideoID,
    wlID: playerStore.getWeblinkID,
});

// COMPUTED PROPERTIES
const logo1 = computed(() => {
    if (props.configurationData) {
        const configurationData = JSON.parse(props.configurationData);
        if (configurationData.logo1) {
            const weblinkID = playerStore.getWeblinkID;
            if (configurationData.logo1.variableName !== '' && weblinkID > 0) {
                return replaceDataVariableInForm(playerStore, props.hotspot, configurationData.logo1);
            } else {
                return '<img class="img-fluid img-logo" alt="V2M" src="'+ configurationData.logo1.url + '">';
            }
        }
    }
    return '';
});

const image1 = computed(() => {
    if (props.configurationData) {
        const configurationData = JSON.parse(props.configurationData);
        if (configurationData.image1) {
            const weblinkID = playerStore.getWeblinkID;
            if (configurationData.image1.variableName !== '' && weblinkID > 0) {
                return replaceDataVariableInForm(playerStore, props.hotspot, configurationData.image1);
            } else {
                return '<img class="img-fluid img-form" alt="V2M" src="'+ configurationData.image1.url + '">';
            }
        }
    }
    return '';
});

// METHODS
const closeModal = () => {
    emit('setClose');
};

const registerField = (fieldName, fieldValue = '') => {
    setFieldValue(fieldName, fieldValue, false); // false = no validar inmediatamente
};

const handleFieldChange = (fieldName, value) => {
    setFieldValue(fieldName, value, hasSubmitted.value); // Solo validar si ya se envió
};

const handleOtherFieldData = (data) => {
    console.log('handleOtherFieldData', data);
    //const key = `question_${data.questionId}_option_${data.optionId}`;
    const key = `question_${data.quetionType}_${data.questionId}_${data.optionId}_text_other`;

    if (data.isSelected && data.otherValue) {
        otherFieldsData.value[key] = data.otherValue;
    } else {
        delete otherFieldsData.value[key];
    }
    console.log('otherFieldsData', otherFieldsData)
};

const submitHandler = async () => {
    hasSubmitted.value = true;

    // Disparar validación
    const { valid } = await validate();

    if (valid) {
        // Serializar datos del formulario
        const formDataSerialize = Object.entries(values).map(([name, value]) => ({
            name,
            value
        }));

        // Agregar datos adicionales de campos "other"
        Object.entries(otherFieldsData.value).forEach(([key, data]) => {
            formDataSerialize.push({
                name: key,
                value: data
            });
        });

        // necesito ordenar el contenido de formDataSerialize por el name para que los campos other esten al final
        formDataSerialize.sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
        });

        await prepareDataAndSave(playerStore, fields.value, formDataSerialize);
        closeModal();
    }
};

// LIFECYCLE HOOKS
(async () => {
    pages.value = props.hotspot ? props.hotspot.pagesForm : 1;

    if (pages.value > 1) {
        myCarousel.value = $('#carousel-' + props.identifierId);
        itemFirst.value = myCarousel.value.find('#carousel-' + props.identifierId + ' .carousel-inner > .carousel-item:first-child');
        itemLast.value = myCarousel.value.find('#carousel-' + props.identifierId + ' .carousel-inner > .carousel-item:last-child');
        const carouselLength = $('#carousel-' + props.identifierId + ' .carousel-inner > .carousel-item').length - 1;
        myCarousel.value.carousel({
            interval: false,
            wrap: false
        }).on('slide.bs.carousel', function (e) {
            pageActive.value = (e.to + 1);
            if (e.to == carouselLength) {
                $('.btn-submit').removeClass('d-none');
                $('.btn-next').addClass('d-none');
                console.log('next me oculto');
            } else if (e.to == 0) {
                $('.btn-submit').addClass('d-none');
                $('.btn-next').removeClass('d-none');
            } else {
                $('.btn-submit').addClass('d-none');
                $('.btn-next').removeClass('d-none');
            }
        });
    }
})();
</script>
